module.exports = __webpack_public_path__ + "static/media/raycast_demo2.d3844a54.jpg";